export const Constants = {
  CLIENT_TOKEN_KEY: "authToken",
  CLIENT_TOKEN_EXPIRATION: "authTokenExpiration",
  USER_TOKEN_KEY: "apiToken",
  USER_TOKEN_EXPIRATION: "apiTokenExpiration",
  USERNAME_KEY: "userName",
  PASSWORD_KEY: "password",
  CLIENT_ID: "SafeFun.Consumer.Web",
  CLIENT_SCOPE: "IdentityServerApi",
  USER_SCOPE: "safefun-api valhalla-api profile openid IdentityServerApi",
  BASE_NAME: "/",
  HOSPITALITY_GROUP_ID_KEY: "hospitalityGroupId",
  APPLICATION_NAME: "safefun-consumer",
  APPLICATION_ID: "applicationId",
  TOS_URL: "https://safefun.com/terms-of-service/",
  PRIVACY_POLICY_URL: "https://safefun.com/privacy-policy",
  TESTING_URL: "https://safefun.com/testing/",
};

export const Paths = {
  CONFIRM_EMAIL: "/confirmemail",
  CONFIRM_ACCOUNT: "/confirmaccount",
  REQUEST_PASSWORD_CHANGE: "/requestpasswordchange",
  RESET_PASSWORD: "/resetpassword",

  // New Consumer Web pages below
  LOGIN: "/login",
  INTRO: "/",
  REGISTRATION: "/registration",
  YOUR_INFO: "/yourinfo",
  WELCOME: "/welcome",
  CHECK_ACCOUNT_STATUS: "/checkaccountstatus",
  CHECK_CONFIRMATION: "/checkconfirmation",
  SAFE_WINDOW: "/safewindow",
  MY_TESTS: "/mytests",
  TEST_DETAIL: "/testdetail",
  PEOPLE: "/people",
  FOLLOWER: "/follower",
  FOLLOWING: "/following",
  ADD_PUBLISHER: "/addpublisher",
  PERSONAL_INFO: "/personalinfo",
  SETTINGS: "/settings",
  TEST_RESULT_VIEWER: "/testresultviewer",
};

export const ErrorMessages = {
  YOU_MUST_ENTER_EMAIL_TO_REGISTER: "You must enter your email to register",
  YOU_MUST_ENTER_PASSWORD_TO_REGISTER: "You must enter a password to register",
  UNEXPECTED_ERROR: "Unexpected Error",
  UNKNOWN_ERROR: (err) => `Unknown Error: ${err}`,
  FAILED_TO_SEND_CONFIRMATION_EMAIL: "Failed to send confirmation email",
  EMAIL_ADDRESS_WRONG_FORMAT:
    "This email address does not have the correct format.  Please check for errors.",
  EMAIL_ADDRESS_ALREADY_IN_USE: `This email address is already in use. Please try logging in with your existing account.`,
  EMAIL_ADDRESS_ALEADY_IN_USE_SELECT_DIFFERENT:
    "This email address is already in use. Please select a different username.",
  INVALID_EMAIL_ADDRESS: "Invalid email address. Please check the spelling.",
  FAILED_EMAIL_AVAILABILITY: "Failed to check email availability",
  FAILED_TO_CHECK_EMAIL_CONFIRMATION: "Failed to check email confirmation.",
  FAILED_TO_SEND_EMAIL_CONFIRMATION: "Failed to send email confirmation.",
  PASSWORD_FORMAT_FAILED:
    "Password must contain at least one upper case, lower case, number, and special character.",
  PLEASE_ENTER_FIRST_NAME: "Please enter your first name.",
  PLEASE_ENTER_LAST_NAME: "Please enter your last name.",
  PLEASE_ENTER_MOBILE_NUMBER: "Please enter your mobile number.",
  FAILED_TO_SAVE_PROFILE_INFO: "Failed to save user profile information.",
  FAILED_TO_LOAD_PROFILE_INFO: "Failed to load personal information.",
  ERROR_CREATING_PAYMENT: "Error creating payment method on Stripe",
  STRIPE_NOT_LOADED: "Stripe not loaded",
  FAILED_TO_AUTH_CC: "Failed to authenticate credit card",
  INSUFFICIENT_FUNDS:
    "Card declined due to insufficient funds. Please provide another form of payment.",
  FAILED_TO_CREATE_SUBSCRIPTION: (err) =>
    `Failed to create subscription: ${err}`,
  FAILED_TO_CHARGE_CC:
    "Failed to charge credit card. Please try another form of payment.",
  FAILED_TO_CHARGE_CC_UNKNOWN_ERROR:
    "Failed to charge credit card. Unknown error.",
  PLEASE_ENTER_BUSINESS_NAME: "Please enter the business name.",
  PLEASE_ENTER_BUSINESS_ADDRESS: "Please enter the business address.",
  PLEASE_ENTER_BUSINESS_CITY: "Please enter the business city.",
  PLEASE_ENTER_BUSINESS_STATE: "Please enter the business state.",
  PLEASE_ENTER_BUSINESS_POSTAL_CODE: "Please enter the business postal code.",
  PLEASE_ENTER_BUSINESS_PHONE: "Please enter the business phone number.",
  ERROR_SAVING_BUSINESS_INFO:
    "There was an error saving your business information",
  ERROR_DELETING_LOCATION_ROLE:
    "There was an error deleting this location/role.  Please try again.",
  ERROR_ADDING_ROLE_TO_USER:
    "There was an error adding the role to the user.  Please try again.",
  FAILED_TO_CHANGE_USERNAME: "Failed to change username.",
  FAILED_TO_CHANGE_PASSWORD: "Failed to change password",
  NEW_PASSWORD_MUST_MATCH: "New Password does not match New Password Confirm",
  PHONE_NUMBER_FORMAT: "Phone number should be formated as (###) ###-####.",
  LOCATION_NAME_REQUIRED: "The location name is required",
  FAILED_TO_SAVE_LOCATION_CHANGES: (err) =>
    `Failed to save location changes. ${err}`,
  FAILED_TO_CREATE_NEW_LOCATION: (err) =>
    `Failed to create new location. ${err}`,
  FAILED_TO_CHANGE_PAYMENT_METHOD: (err) =>
    `Failed to change payment method. ${err}`,
  FAILED_TO_LOAD_BILLING_INFO: "Failed to load billing information.",
  MISSING_EMAIL_PARAMETER: "Missing email parameter",
  MISSING_TOKEN_PARAMETER: "Missing token parameter",
  FAILED_TO_CONFIRM_EMAIL: "Failed to confirm email.",
};
